import React from 'react';
import iaoeil from '../../../../assets/conference/iaoeil.png';

const EndSlide = ({ slide, slideKey }) => {
    return (
        <div key={slideKey} className="h-full flex flex-col items-center justify-center p-12 text-center relative overflow-hidden">
            {/* Arrière-plan animé */}
            <div className="absolute inset-0 opacity-5">
                {[...Array(30)].map((_, i) => (
                    <div key={i} className="absolute rounded-full bg-blue-500"
                        style={{
                            left: `${Math.random() * 100}%`,
                            top: `${Math.random() * 100}%`,
                            width: `${4 + Math.random() * 8}px`,
                            height: `${4 + Math.random() * 8}px`,
                            animation: `float ${3 + Math.random() * 4}s ease-in-out infinite`,
                            animationDelay: `${Math.random() * 2}s`
                        }}
                    />
                ))}
            </div>

            <div className="relative z-10 max-w-5xl space-y-8">
                {/* Titre principal */}
                <h1 className="text-8xl md:text-9xl font-black bg-gradient-to-r from-blue-400 via-cyan-400 to-blue-400 bg-clip-text text-transparent animate-fade-in-scale">
                    {slide.title}
                </h1>

                {/* Sous-titre */}
                <p className="text-3xl md:text-4xl text-blue-200/90 font-light animate-fade-in-up stagger-1">
                    {slide.subtitle}
                </p>

                {/* Image centrale */}
                <div className="flex justify-center animate-fade-in-up stagger-2">
                    <img
                        src={iaoeil}
                        alt="IA Oeil"
                        className="w-64 h-auto rounded-2xl shadow-2xl shadow-blue-500/20 hover:shadow-blue-500/40 hover:scale-105 transition-all duration-300"
                    />
                </div>

                {/* Citation inspirante */}
                <blockquote className="relative px-8 py-6 animate-fade-in-up stagger-3">
                    <div className="absolute top-0 left-0 text-6xl text-blue-400/20 font-serif">"</div>
                    <p className="text-2xl md:text-3xl text-blue-100/90 font-light italic leading-relaxed">
                        Libérez-vous de la syntaxe. Devenez l'architecte de votre intention et redonnez au génie humain sa véritable puissance : celle de concevoir.
                    </p>
                    <div className="absolute bottom-0 right-0 text-6xl text-blue-400/20 font-serif">"</div>
                </blockquote>

                {/* Carte de contact */}
                <div className="inline-block animate-fade-in-up stagger-4">
                    <div className="bg-slate-900/70 backdrop-blur-md border border-blue-500/30 rounded-2xl p-8 hover:border-blue-400/50 hover:shadow-lg hover:shadow-blue-500/20 transition-all duration-300">
                        <div className="flex items-center gap-8">
                            {/* QR Code */}
                            <div className="flex-shrink-0">
                                <img
                                    src="https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=www.linkedin.com/in/adrien-giguelay-96975987"
                                    alt="LinkedIn QR"
                                    className="w-36 h-36 rounded-xl bg-white p-3 shadow-lg hover:scale-110 transition-transform duration-300"
                                />
                            </div>

                            {/* Informations de contact */}
                            <div className="text-left space-y-3">
                                <p className="text-4xl font-bold text-white">
                                    {slide.contact.name}
                                </p>
                                <div className="space-y-2">
                                    <p className="text-lg text-blue-300/90 font-mono flex items-center gap-2">
                                        <span className="text-blue-400">●</span>
                                        {slide.contact.linkedin}
                                    </p>
                                    <p className="text-lg text-cyan-300/90 font-mono flex items-center gap-2">
                                        <span className="text-cyan-400">●</span>
                                        {slide.contact.website}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EndSlide;
